import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const medalsContainer = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: space.s5,
});

export const quantity = style({
  selectors: {
    [`${medalsContainer} &`]: {
      ...typography['bodySm'],

      color: themeVars.container.foreground.tertiary,
    },
  },
});
